import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./style/PriceTab.module.css";
import {
  Button,
  Form,
  FormControl,
  InputGroup,
  Nav,
  Tab,
} from "react-bootstrap";
import clsx from "clsx";
import { TabTitle } from "@components";
import { useFormik } from "formik";
import { editingCourseActions, updateCourseAction } from "@redux/actions";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { CourseContext } from "..";

const PriceTab = () => {
  const dispatch = useDispatch();
  const { step, setStep, isUpdate, autoSave, setAutoSave } =
    useContext(CourseContext);

  const validationSchema = Yup.object().shape({
    price: Yup.number().when("isFree", {
      is: (val) => val != true,
      then: Yup.number()
        .min(10, "Price must be equal or greater than 10$")
        .max(1000, "Price can't be higher than 1000$")
        .required("Price is require"),
    }),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      requireLogin: false,
      requireEnroll: false,
      price: 0,
      discountPrice: 0,
      isFree: false,
    },
    validationSchema,
    onSubmit: (values) => {
      handleSaveChange();
      setStep(step + 1);
    },
  });

  const editingCourse = useSelector((state) => state.course.editingCourse);

  const [tab, setTab] = useState("paid");

  useEffect(() => {
    if (isUpdate) {
      setFieldValue("requireLogin", editingCourse.requireLogin);
      setFieldValue("requireEnroll", editingCourse.requireEnroll);
      setFieldValue("price", editingCourse.price);
      setFieldValue("isFree", editingCourse.isFree);
      setFieldValue("discountPrice", editingCourse.discountPrice);
      if (editingCourse.isFree) {
        setTab("free");
      } else {
        setTab("paid");
      }
    }
  }, [isUpdate, editingCourse]);

  function handleSelect(key) {
    if (key == "free") {
      setTab("free");
      setFieldValue("isFree", true);
    } else {
      setTab("paid");
      setFieldValue("isFree", false);
    }

    // dispatch(editingCourseActions.changeCourseType(k));
  }

  const handleSaveChange = async () => {
    await dispatch(editingCourseActions.changePriceInfo(values));
    dispatch(updateCourseAction());
  };
  return (
    <div className="container ">
      <Form onSubmit={handleSubmit}>
        <TabTitle
          onSave={handleSaveChange}
          isAutoSave={autoSave}
          setAutoSave={setAutoSave}
        >
          <i className="bi bi-plus-square mr-2"></i>Price
        </TabTitle>
        <div className={clsx(styles.tabContainer, "container bg-white p-4")}>
          <Tab.Container
            defaultActiveKey="free"
            onSelect={handleSelect}
            activeKey={tab}
          >
            <Nav
              variant="pills"
              className="mt-3 mb-4 container justify-content-center"
            >
              <Nav.Item>
                <Nav.Link eventKey="paid">Paid</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="free">Free</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="free">
                <div className="d-flex flex-column align-items-center gap-3">
                  {/* <Form> */}
                  {/* <Form.Check
                    name="requireLogin"
                    type="switch"
                    id="custom-switch"
                    label="Require Log In"
                    onChange={handleChange}
                    value={values.requireLogin}
                    checked={values.requireLogin}
                    isInvalid
                  />
                  <Form.Check
                    name="requireEnroll"
                    type="switch"
                    id="custom-switch"
                    label="Require Enroll"
                    onChange={handleChange}
                    value={values.requireEnroll}
                    checked={values.requireEnroll}
                    isInvalid
                  /> */}
                  {/* </Form> */}
                  <span>
                    If you chose this options, this course will be free!!
                    Students will just need to login and access your course for
                    free.
                  </span>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="paid">
                <div className="">
                  <Form.Label>Price</Form.Label>
                  <InputGroup className="mb-3 w-100">
                    <FormControl
                      placeholder="$0"
                      name="price"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.price}
                      type="number"
                      isInvalid={touched.price && errors.price}
                    />
                    <InputGroup.Text id="basic-addon2">USD</InputGroup.Text>
                    <Form.Control.Feedback type="invalid" className="text-left">
                      {touched.price && errors.price}
                    </Form.Control.Feedback>
                  </InputGroup>

                  {/* <Form.Label>Discount Price*</Form.Label>
                  <InputGroup className="mb-3 w-50">
                    <FormControl
                      placeholder="$0"
                      name="discountPrice"
                      onChange={handleChange}
                      value={values.discountPrice}
                      type="number"
                    />
                    <InputGroup.Text id="basic-addon2">USD</InputGroup.Text>
                  </InputGroup> */}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
        <div className=" d-flex justify-content-between mt-5">
          <Button
            variant="primary"
            onClick={() => {
              setStep(step - 1);
            }}
            disabled={step == 1 ? true : false}
          >
            Prev
          </Button>

          <Button variant="primary" type="submit">
            Next
          </Button>
        </div>
      </Form>
    </div>
  );
};

/* required: display name */
PriceTab.displayName = "PriceTab";

/* required: props types */
PriceTab.propTypes = {};

/* required: default props */
PriceTab.defaultProps = {};

export { PriceTab };
